/** Phần thuần của form Thông báo cập nhật (Platform) — chuyển form ⇄ dữ liệu API. */
import dayjs from 'dayjs'
import type { PlatformReleaseNote, ReleaseNoteInput } from '@/hooks/use-platform-release-notes'

export interface ReleaseNoteForm {
  slug: string
  title: string
  date: string // YYYY-MM-DD
  highlightsText: string // mỗi dòng một nhóm tính năng
  html: string
  maxShows: string
  isActive: boolean
}

export const emptyReleaseForm = (html = ''): ReleaseNoteForm => {
  const date = dayjs().format('YYYY-MM-DD')
  return { slug: date, title: '', date, highlightsText: '', html, maxShows: '3', isActive: true }
}

export const noteToForm = (n: PlatformReleaseNote): ReleaseNoteForm => ({
  slug: n.slug, title: n.title, date: dayjs(n.releasedAt).format('YYYY-MM-DD'),
  highlightsText: n.highlights.join('\n'), html: n.html, maxShows: String(n.maxShows), isActive: n.isActive,
})

export const parseHighlights = (text: string): string[] => text.split('\n').map((l) => l.trim()).filter(Boolean)

export function validateReleaseForm(f: ReleaseNoteForm): string | null {
  if (!/^[a-z0-9][a-z0-9-]{0,39}$/.test(f.slug.trim().toLowerCase())) return 'Mã bản chỉ gồm chữ thường, số, gạch nối (vd 2026-10-10)'
  if (!f.title.trim()) return 'Nhập tiêu đề'
  if (!dayjs(f.date).isValid()) return 'Ngày phát hành không hợp lệ'
  const hl = parseHighlights(f.highlightsText)
  if (hl.length === 0) return 'Nhập ít nhất một dòng tính năng'
  if (hl.length > 12) return 'Tối đa 12 dòng tính năng'
  if (!f.html.trim()) return 'Dán hoặc tải HTML animation'
  if (f.html.length > 300_000) return 'HTML tối đa 300KB'
  const n = Number(f.maxShows)
  if (!Number.isInteger(n) || n < 1 || n > 20) return 'Số lần hiện tối đa từ 1 đến 20'
  return null
}

export const formToInput = (f: ReleaseNoteForm): ReleaseNoteInput => ({
  slug: f.slug.trim().toLowerCase(), title: f.title.trim(), releasedAt: dayjs(f.date).toDate().toISOString(),
  highlights: parseHighlights(f.highlightsText), html: f.html, maxShows: Number(f.maxShows), isActive: f.isActive,
})
